// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MACx","col":"styles_col__1J5iN"};